const statusConfig: Record<string, { label: string }> = {
  pending:            { label: "Pending" },
  document_verified:  { label: "Docs Verified" },
  course_assigned:    { label: "Course Assigned" },
  course_in_progress: { label: "In Progress" },
  course_completed:   { label: "Completed" },
  eligible_for_exam:  { label: "Eligible for Exam" },
  exception:          { label: "Exemption" },
  sent_for_approval:  { label: "Sent for Approval" },
  approved:           { label: "Approved" },
  rejected:           { label: "Rejected" },
  paid:               { label: "Certified" },
  certified:          { label: "Certified" },
  under_review:       { label: "Under Review" },
  payment_pending:    { label: "Payment Pending" },
};

const StatusBadge = ({ status }: { status: string }) => {
  const config = statusConfig[status] || { label: status };
  return (
    <span className="text-xs font-semibold text-muted-foreground max-w-[72px] inline-block leading-tight">
      {config.label}
    </span>
  );
};

export default StatusBadge;
